import { execOnLoad } from '@general/helpers';
import './password-page.scss';

if (!window.dAgency) window.dAgency = {};
window.dAgency.initPasswordPage = (context) => {
  const sectionContainer = context.classList.contains('shopify-section')
    ? context
    : context.closest('.shopify-section');
  if (!sectionContainer) return;

  const showButton = sectionContainer.querySelector('.password-page__toggle');
  const container = sectionContainer.querySelector('.password-page__container');
  if (showButton && container)
    showButton.addEventListener('click', () => container.classList.toggle('password-page__container--show-form'));
};

execOnLoad(window.dAgency.initPasswordPage, '.password-page__section');
